<template>
	<div>
		<a-page-header style="background: #fff;" title="商品分类" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'商品管理'},{breadcrumbName:'商品分类'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加分类
				</a-button>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="classPic" slot-scope="classPic">
						<a-avatar :src="classPic" size="large" />
					</span>
					<span slot="classUp" slot-scope="classUp">
						<a-tag color="blue" v-if="classUp">{{classUp}}</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加分类弹出 -->
		<a-modal title="添加分类" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="分类名称" prop="className">
					<a-input v-model="addForm.className"></a-input>
				</a-form-model-item>
				<a-form-model-item label="分类图标" prop='classPic'>
					<a-upload name="img" :multiple="true" listType="picture-card" :showUploadList="false" class="avatar-uploader"
					 :action="this.$host+'/admin/index.php/admin/qiniu/uploads'" @change="addPicChange">
						<img v-if="addForm.classPic" :src="addForm.classPic" alt="avatar" style=" width: 150px;height: 150px;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item label="上级分类" prop='classUp'>
					<a-select v-model="addForm.classUp" :options="classList">
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="排序" prop="order">
					<a-input v-model="addForm.order"></a-input>
					<div style="color: #ffa940;">数字越大排序越靠前 例如 100 > 99</div>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改分类弹出 -->
		<a-modal title="编辑分类" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="保存" width="50%">
			<a-form-model ref="editForm" :model="editForm" :rules="addRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="分类名称" prop="className">
					<a-input v-model="editForm.className"></a-input>
				</a-form-model-item>
				<a-form-model-item label="分类图标" prop='classPic'>
					<a-upload name="img" :multiple="true" listType="picture-card" :showUploadList="false" class="avatar-uploader"
					 :action="this.$host+'/admin/index.php/admin/qiniu/uploads'" @change="editPicChange">
						<img v-if="editForm.classPic" :src="editForm.classPic" alt="avatar" style=" width: 150px;height: 150px;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item label="上级分类" prop='classUp'>
					<a-select v-model="editForm.classUp" :options="classList">
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="排序" prop="order">
					<a-input v-model="editForm.order"></a-input>
					<div style="color: #ffa940;">数字越大排序越靠前 例如 100 > 99</div>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '分类名称',
			dataIndex: 'className',
			scopedSlots: {
				customRender: 'className'
			},
		},
		{
			title: '分类图标',
			dataIndex: 'classPic',
			scopedSlots: {
				customRender: 'classPic'
			},
		},
		{
			title: '上级分类',
			dataIndex: 'classUp',
			scopedSlots: {
				customRender: 'classUp'
			},
		},
		{
			title: '排序',
			dataIndex: 'order',
			scopedSlots: {
				customRender: 'order'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				classList: [],
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {},
				addModal: false,
				editForm: {},
				editModal: false,
				loading: false,
				addRules: {
					className: [{
						required: true,
						message: '请填写分类名称',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
			this.getClassList()
		},

		methods: {
			addPicChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.addForm.classPic = info.file.response.url;
					this.loading = false;
				}
			},
			editPicChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.editForm.classPic = info.file.response.url;
					this.loading = false;
				}
			},

			toDetail(id) {
				this.classId = id
				this.$http.post('/admin/index.php/admin/Shop/comnnodityClassInfo', {
					id: id
				}).then(res => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						this.editModal = true
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Shop/comnnodityClassSave', {
							className: this.addForm.className,
							classPic: this.addForm.classPic, //JSON.stringify(housetypePic)
							classUp: this.addForm.classUp,
							order: this.addForm.order,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			editSubmit() {
				this.$refs.editForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Shop/comnnodityClassSave', {
							id:this.classId,
							className: this.editForm.className,
							classPic: this.editForm.classPic, //JSON.stringify(housetypePic)
							classUp: this.editForm.classUp,
							order: this.editForm.order,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('保存成功！');
								this.editModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Shop/comnnodityClassDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
				}
				this.$http.post('/admin/index.php/admin/Shop/comnnodityClassList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getClassList() {
				this.$http.get('/admin/index.php/admin/Shop/classPullListOne').then(res => {
					if (res.data.code == 1) {
						this.classList = res.data.data
					}
				})
			}
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
